import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
    // Hent fra localStorage hvis det finnes, ellers null
    const getInitialSelectedActivity = () => {
        try {
            const stored = localStorage.getItem('selectedActivity');
            return stored ? JSON.parse(stored) : null;
        } catch (e) {
            return null;
        }
    };
    const [selectedActivity, setSelectedActivity] = useState(getInitialSelectedActivity);

    // Lagre til localStorage når selectedActivity endres
    React.useEffect(() => {
        if (selectedActivity) {
            localStorage.setItem('selectedActivity', JSON.stringify(selectedActivity));
        } else {
            localStorage.removeItem('selectedActivity');
        }
    }, [selectedActivity]);

    return (
        <ActivityContext.Provider value={{ selectedActivity, setSelectedActivity }}>
            {children}
        </ActivityContext.Provider>
    );
};

export const useActivity = () => useContext(ActivityContext);

ActivityProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
